import BigNumber from 'bignumber.js'
import { Token } from '../atoms'
import { getToken, toDisplay, toWei } from '../model/tokens/helper'
import { CLPosition } from '../model/clpool'
import { getTokenBraavosName } from '.'
import { Network } from '../services/token.service'
import { getPriceFromState } from '../model/pricing/helper'

export function getAmount1FromAmount0(amount0: string, token0: Token, token1: Token, minTick: number, maxTick: number, currentTick: number): string {
    return _getAmount1FromAmount0(amount0, token0, token1, minTick, maxTick, BigNumber(Math.sqrt(1.0001 ** currentTick)))
}
export function _getAmount1FromAmount0(amount0: string, token0: Token, token1: Token, minTick: number, maxTick: number, currentSqrtRatio: BigNumber): string {
    console.log('getAmount1FromAmount0 currentSqrtRatio ', currentSqrtRatio.toNumber())
    console.log('YSYS getAmount1FromAmount0 tick_low=', minTick, ' maxTick=', maxTick)
    const sqrtA = Math.sqrt(1.0001 ** minTick)
    const sqrtB = Math.sqrt(1.0001 ** maxTick)
    //const current = Math.sqrt(1.0001 ** currentTick)
    const liq = getLiquidityForAmount0(BigNumber(sqrtA), BigNumber(sqrtB), currentSqrtRatio, BigNumber(toWei(amount0, token0)))
    if (liq.isEqualTo(0) && Number(amount0) !== 0) {
        throw new Error('Cannot add this position')
    }
    const amount1 = getAmount1ForLiquidity(BigNumber(sqrtA), BigNumber(sqrtB), currentSqrtRatio, liq)
    console.log('YSYS getAmount1FromAmount0 low=', sqrtA, ' high=', sqrtB, ' current=', currentSqrtRatio.toFixed(10))

    console.log('YSYS getAmount1FromAmount0 token0=', toWei(amount0, token0), ' liquidity=', liq.toFixed(0), ' token1=', amount1.toFixed())

    return toDisplay(amount1, token1)
}

export function getAmount0FromAmount1(amount1: string, token0: Token, token1: Token, minTick: number, maxTick: number, currentTick: number): string {
    return _getAmount0FromAmount1(amount1, token0, token1, minTick, maxTick, BigNumber(Math.sqrt(1.0001 ** currentTick)))
}

export function _getAmount0FromAmount1(amount1: string, token0: Token, token1: Token, minTick: number, maxTick: number, currentSqrtRatio: BigNumber): string {
    // console.log('YSYS getAmount0FromAmount1 tick_low=', minTick, ' maxTick=', maxTick)

    const sqrtA = Math.sqrt(1.0001 ** minTick)
    const sqrtB = Math.sqrt(1.0001 ** maxTick)
    //const current = Math.sqrt(1.0001 ** currentTick)
    const liq = getLiquidityForAmount1(BigNumber(sqrtA), BigNumber(sqrtB), currentSqrtRatio, BigNumber(toWei(amount1, token1)))
    if (liq.isEqualTo(0) && Number(amount1) !== 0) {
        throw new Error('Cannot add this position')
    }

    // console.log('YSYS getAmount0FromAmount1 low=', sqrtA, ' high=', sqrtB, ' current=', currentSqrtRatio.toFixed(10))

    const amount0 = getAmount0ForLiquidity(BigNumber(sqrtA), BigNumber(sqrtB), currentSqrtRatio, liq)

    // console.log('YSYS getAmount0FromAmount1 token1=', toWei(amount1, token1), ' liquidity=', liq.toFixed(0), ' token0=', amount0.toFixed())
    return toDisplay(amount0, token0)
}

// liquidity math
export function getLiquidityForAmount0(sqrtRatioA: BigNumber, sqrtRatioB: BigNumber, currentSqrtRatio: BigNumber, amount0Wei: BigNumber): BigNumber {
    if (currentSqrtRatio.isLessThanOrEqualTo(sqrtRatioA)) {
        return sqrtRatioA.multipliedBy(sqrtRatioB).multipliedBy(amount0Wei).dividedBy(sqrtRatioB.minus(sqrtRatioA))
    }
    if (currentSqrtRatio.isLessThan(sqrtRatioB)) {
        return currentSqrtRatio.multipliedBy(sqrtRatioB).multipliedBy(amount0Wei).dividedBy(sqrtRatioB.minus(currentSqrtRatio))
    }
    // in this range there is no amount0
    return BigNumber(0)
}

export function getAmount1ForLiquidity(sqrtRatioA: BigNumber, sqrtRatioB: BigNumber, currentSqrtRatio: BigNumber, liquidity: BigNumber): BigNumber {
    if (currentSqrtRatio.isLessThanOrEqualTo(sqrtRatioA)) {
        // in this range there is no amount1
        return BigNumber(0)
        //return sqrtRatioA.multipliedBy(sqrtRatioB).multipliedBy(amount0Wei).dividedBy(sqrtRatioB.minus(sqrtRatioA))
    }
    if (currentSqrtRatio.isLessThan(sqrtRatioB)) {
        //            amount1 = getAmount1ForLiquidity(sqrtRatioAX96, sqrtRatioX96, liquidity);
        return liquidity.multipliedBy(currentSqrtRatio.minus(sqrtRatioA))
    }

    return liquidity.multipliedBy(sqrtRatioB.minus(sqrtRatioA))
}

export function getLiquidityForAmount1(sqrtRatioA: BigNumber, sqrtRatioB: BigNumber, currentSqrtRatio: BigNumber, amount1Wei: BigNumber): BigNumber {
    if (currentSqrtRatio.isLessThanOrEqualTo(sqrtRatioA)) {
        return BigNumber(0)
    }
    if (currentSqrtRatio.isLessThan(sqrtRatioB)) {
        return amount1Wei.dividedBy(currentSqrtRatio.minus(sqrtRatioA))
    }
    return amount1Wei.dividedBy(sqrtRatioB.minus(sqrtRatioA))
}

export function getAmount0ForLiquidity(sqrtRatioA: BigNumber, sqrtRatioB: BigNumber, currentSqrtRatio: BigNumber, liquidity: BigNumber): BigNumber {
    if (currentSqrtRatio.isLessThanOrEqualTo(sqrtRatioA)) {
        return liquidity.multipliedBy(sqrtRatioB.minus(sqrtRatioA)).dividedBy(sqrtRatioA).dividedBy(sqrtRatioB)
    }
    if (currentSqrtRatio.isLessThan(sqrtRatioB)) {
        return liquidity.multipliedBy(sqrtRatioB.minus(currentSqrtRatio)).dividedBy(currentSqrtRatio).dividedBy(sqrtRatioB)
    }

    return BigNumber(0)
}

export function getPercentageOfLiquidityForPosition(currentRatio: string | BigNumber, clPosition: CLPosition | undefined) {
    if (!currentRatio) return { percentage1: 0, percentage2: 0 }
    if (!clPosition || !clPosition?.value) return { percentage1: 0, percentage2: 0 }
    const fee1 = BigNumber(clPosition?.fees?.token1AmountWei!)
    const fee2 = BigNumber(clPosition?.fees?.token2AmountWei!)
    let amount1 = BigNumber(clPosition?.value.token1AmountWei!).minus(fee1)
    let amount2 = BigNumber(clPosition?.value.token2AmountWei!).minus(fee2)
    if (amount1.isLessThan(0)) amount1 = BigNumber(0)
    if (amount2.isLessThan(0)) amount2 = BigNumber(0)

    const totalLiquidity = amount1.multipliedBy(BigNumber(currentRatio)).plus(amount2)

    const percentageToken1 = amount1.multipliedBy(BigNumber(currentRatio)).dividedBy(totalLiquidity).multipliedBy(100)
    const percentageToken2 = amount2.dividedBy(totalLiquidity).multipliedBy(100)

    return { percentage1: percentageToken1.toFixed(1), percentage2: percentageToken2.toFixed(1) }
}

export function calculateTotalLiquidityUsdPerPosition(clPosition: CLPosition | undefined, network: Network, onlyPrincipal = false) {
    if (!clPosition || !clPosition.value) return '0'

    let token1Amount = BigNumber(clPosition?.value.token1Amount!)
    let token2Amount = BigNumber(clPosition?.value.token2Amount!)
    const token1 = getToken(network!, clPosition?.token0!)
    const token2 = getToken(network!, clPosition?.token1!)
    const token1Name = getTokenBraavosName(token1?.symbol!)
    const token2Name = getTokenBraavosName(token2?.symbol!)
    const token1Price = getPriceFromState(token1Name) ? getPriceFromState(token1Name)!.usd : 0
    const token2Price = getPriceFromState(token2Name) ? getPriceFromState(token2Name)!.usd : 0

    if (onlyPrincipal) {
        // subtract the accrued fees
        const token1FeesBn = BigNumber(clPosition?.fees?.token1Amount! ?? 0)
        const token2FeesBn = BigNumber(clPosition?.fees?.token2Amount! ?? 0)
        token1Amount = token1Amount.minus(token1FeesBn)
        token2Amount = token2Amount.minus(token2FeesBn)
    }
    return token1Amount.multipliedBy(token1Price).plus(token2Amount.multipliedBy(token2Price)).toFixed(4)
}

export function calculateTotalUnclaimedFees(clPosition: CLPosition | undefined, network: Network) {
    if (!clPosition || !clPosition.fees) return '0'

    let token1Amount = BigNumber(clPosition.fees.token1Amount!)
    let token2Amount = BigNumber(clPosition.fees.token2Amount!)
    const token1 = getToken(network!, clPosition?.token0!)
    const token2 = getToken(network!, clPosition?.token1!)
    const token1Name = getTokenBraavosName(token1?.symbol!)
    const token2Name = getTokenBraavosName(token2?.symbol!)
    const token1Price = getPriceFromState(token1Name) ? getPriceFromState(token1Name)!.usd : 0
    const token2Price = getPriceFromState(token2Name) ? getPriceFromState(token2Name)!.usd : 0

    return token1Amount.multipliedBy(token1Price).plus(token2Amount.multipliedBy(token2Price)).toFixed(4)
}
